import script from "./ArchiveViewOrganism.vue?vue&type=script&setup=true&lang=js"
export * from "./ArchiveViewOrganism.vue?vue&type=script&setup=true&lang=js"

import "./ArchiveViewOrganism.vue?vue&type=style&index=0&id=48019ab9&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-48019ab9"]])

export default __exports__